var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.projects), function(project_obj, index) {
    return _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "card border-info rounded",
      staticStyle: {
        "background-color": "#4b8cbb",
        "box-shadow": "0 6px 10px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
      }
    }, [_c('div', {
      staticClass: "card-body",
      staticStyle: {
        "align-self": "center",
        "padding-bottom": "0.4rem"
      }
    }, [_c('h6', {
      staticClass: "card-title text-white font-weight-bold"
    }, [_vm._v(_vm._s(project_obj.projectname))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "align-self": "center",
        "margin-bottom": "1em"
      }
    }, [_c('button', {
      staticClass: "btn btn-light",
      on: {
        "click": function($event) {
          _vm.redirectToLogin(project_obj.appurl, project_obj.projectid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(" Sign in")])])])])])
  })), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ca3578","hasScoped":true}!./src/views/components/dashboard/dashboard.component.html
// module id = 401
// module chunks = 1